export const RequestHeader = {
  CSRF_TOKEN: 'X-CSRF-TOKEN',
};
